module.exports = __webpack_public_path__ + "img/登录验证4.765fa3b4.jpg";